/* eslint-disable @angular-eslint/prefer-standalone */
import { Component, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dashboard-no-results-opportunities',
  templateUrl: './no-results-opportunities.component.html',
  styleUrls: ['./no-results-opportunities.component.scss'],
  standalone: false
})
export class NoResultsOpportunitiesComponent {
  @Output() public back = new EventEmitter<void>();

  public constructor(private router: Router) {}
  public goToOpportunities(): void {
    this.router.navigate(['opportunities', 'community']);
  }

  public onBack(): void {
    this.back.emit();
  }
}
